"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var convert_currency_1 = require("../convert_currency");
var sanitized_render_1 = require("../components/sanitized_render");
var OffersCurrencyConversion = /** @class */ (function (_super) {
    tslib_1.__extends(OffersCurrencyConversion, _super);
    function OffersCurrencyConversion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OffersCurrencyConversion.prototype.convertAmount = function (amount) {
        return convert_currency_1.convertCurrency(this.props.userCurrency, this.props.shopCurrency, this.props.rates, amount).display;
    };
    OffersCurrencyConversion.prototype.formatAmount = function (price) {
        var currency = this.props.shopCurrency;
        var spanOpen = '<span class="size-80 weight-normal">';
        var spanClose = '</span>';
        return price + " " + spanOpen + currency + spanClose;
    };
    OffersCurrencyConversion.prototype.offerApproximation = function (offerAmount, shippingPrice) {
        var convertedOfferAmount = this.convertAmount(offerAmount);
        if (shippingPrice) {
            return I18n.t('commons.offers.currencyApproximation', {
                offerAmount: this.formatAmount(convertedOfferAmount),
                shippingPrice: this.formatAmount(shippingPrice.display),
            });
        }
        return I18n.t('commons.offers.currencyApproximationUnknownShipping', {
            offerAmount: this.formatAmount(convertedOfferAmount),
        });
    };
    OffersCurrencyConversion.prototype.render = function () {
        var _a = this.props, offerAmount = _a.offerAmount, shippingPrice = _a.shippingPrice, shopCurrency = _a.shopCurrency, userCurrency = _a.userCurrency;
        var tooltipText = I18n.t('commons.offers.sellerCurrencyWarning', {
            shopCurrency: shopCurrency,
            userCurrency: userCurrency,
        });
        if (!offerAmount) {
            return null;
        }
        if (userCurrency === shopCurrency) {
            return null;
        }
        return (React.createElement("section", { className: "offers-currency-conversion" },
            React.createElement("h1", { className: "offers-currency-conversion__title" },
                React.createElement(sanitized_render_1.default, { html: this.offerApproximation(offerAmount, shippingPrice) })),
            React.createElement("p", null,
                I18n.t('commons.offers.valueMayVary', { userCurrency: userCurrency, shopCurrency: shopCurrency }),
                React.createElement("span", { className: "tooltip", "data-tooltip-text": tooltipText },
                    React.createElement("span", { className: "offers-currency-conversion__icon" })))));
    };
    return OffersCurrencyConversion;
}(React.Component));
exports.default = OffersCurrencyConversion;
//# sourceMappingURL=offers_currency_conversion.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offers_currency_conversion.js
// module id = Td1v
// module chunks = 20 21